"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tabs_1 = require("./Tabs");
var TabPanel = function (props) {
    var children = props.children, className = props.className, identifier = props.identifier;
    var _a = Tabs_1.useTabsContext(), switches = _a.switches, isActiveTab = _a.isActiveTab;
    var isPanelActive = isActiveTab([identifier]);
    var tabIndex = isPanelActive ? 0 : -1;
    return switches[identifier] ? (react_1.default.createElement("div", { "aria-labelledby": "tabs--" + identifier, role: "tabpanel", tabIndex: tabIndex, hidden: !isPanelActive, className: "tabs__panel " + (className || '') }, children)) : null;
};
exports.default = TabPanel;
//# sourceMappingURL=TabPanel.js.map